import React from 'react'
import FrontendLayout from '../FrontendLayout'
import Hero from '../front-components/Hero'
import About from '../front-components/About'
import Team from '../front-components/Team'
import Facts from '../front-components/Facts'
import Feature from '../front-components/Feature'
import Testimonial from '../front-components/Testimonial'

export default function Aboutus() {
  return (
    <FrontendLayout>
        <Hero title="About Us" />
        <About />
        <Facts />
        <Feature />
        <Team />
        {/* <Testimonial /> */}
    </FrontendLayout>
    
  )
}
